import deleteMeetingMessage from '../actions/deleteMeetingMessage';
import removeCancelledMeetingFromCalendar from '../actions/removeCancelledMeetingFromCalendar';
import { default as logMeetingMessageAction } from '../utils/logMeetingMessageAction';
import { removeCancelledMeetingFromCalendar as removeCancelledMeetingFromCalendarAction } from 'owa-meeting-message-actions';
import { orchestrator } from 'satcheljs';

orchestrator(removeCancelledMeetingFromCalendar, ({ item, entrySource }) => {
    deleteMeetingMessage(item);
    logMeetingMessageAction('RemoveFromCalendar', item, entrySource);
    removeCancelledMeetingFromCalendarAction(item, 'MailListMessage');
});
